import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useTimer } from '../hooks';
import media from '../style/media';
import { useMediaPredicate } from 'react-media-hook';

const Value = styled.div`
  font-size: 1.5rem;
  font-weight: 800;
  color: white;
  background: rgba(255, 255, 255, 0.1);
  padding: 8px 16px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-variant-numeric: tabular-nums;
  margin-top: 0;
`;


const Timer = ({ started, durationSeconds }) => {
  const isMediaTablet = useMediaPredicate('(min-width: 1000px)');
  const seconds = useTimer(started, durationSeconds);
  const formatMinutes = useCallback(
    (seconds) => ('0' + Math.floor(seconds / 60)).slice(-2),
    [seconds],
  );
  const formatSeconds = useCallback(
    (seconds) => ('0' + (seconds % 60)).slice(-2),
    [seconds],
  );
  return (
    <Value>
      {!isMediaTablet && 'Duration: '}
      {formatMinutes(seconds)}:{formatSeconds(seconds)}
    </Value>
  );
};

export default Timer;
